import { Theme } from '@mui/system'
import buttonStyle from '../../materialUI/components/CustomButtons/buttonStyle'
import {
  cardTitle,
  grayColor,
  whiteColor,
} from '../../materialUI/jss/material-dashboard-pro-react'

const forgotPasswordPageStyle = {
  container: (theme: Theme) => ({
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    '@media (min-width: 768px)': {
      width: '100%',
    },
    '@media (min-width: 992px)': {
      width: '100%',
    },
    '@media (min-width: 1200px)': {
      width: '100%',
    },
    '&:before,&:after': {
      display: 'table',
      content: '" "',
    },
    '&:after': {
      clear: 'both',
    },
    zIndex: '4',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '100px',
    },
  }),
  cardTitle: {
    ...cardTitle,
    color: 'black',
    marginTop: '10px',
    marginBottom: '10px',
  },
  textCenter: {
    textAlign: 'center',
  },
  justifyContentCenter: {
    justifyContent: 'center !important',
  },
  customButtonClass: {
    '&,&:focus,&:hover': {
      color: whiteColor,
    },
    marginLeft: '5px',
    marginRight: '5px',
  },
  inputAdornment: {
    marginRight: '18px',
  },
  inputAdornmentIcon: {
    color: grayColor[6],
  },
  cardHidden: {
    opacity: '0',
    transform: 'translate3d(0, -60px, 0)',
  },
  cardHeader: {
    marginBottom: '20px',
  },
  socialLine: {
    padding: '0.9375rem 0',
  },
  errorLabel: {
    color: 'red',
    textAlign: 'center',
  },
  errorContainer: {
    justifyContent: 'center',
    textAlign: 'center',
  },
  forgotPasswordBtn: {
    // width: "100%",
    float: 'center',
  },
  ...buttonStyle,
}

export default forgotPasswordPageStyle
